import Toast from './Toast.vue';

export default Toast;
